import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { MoreNavs } from './Settings.styles';
import JobFilter from 'pages/jobs/JobFilter';
import { useTranslation } from 'react-i18next';
import { Capacitor } from '@capacitor/core';

import { ReactComponent as UserProfilePic } from 'assert/images/Navbar/userProfile.svg';
import { ReactComponent as Work } from 'assert/images/Navbar/work.svg';
import { ReactComponent as Settings } from 'assert/images/Navbar/settings.svg';
import { ReactComponent as JobAlert } from 'assert/images/Jobs/addAlert.svg';
import { ReactComponent as Arrowforward } from 'assert/images/Common/arrowForward.svg';
import { ReactComponent as AppleStore } from 'assert/images/Navbar/appleStore.svg';
import { ReactComponent as AndroidStore } from 'assert/images/Navbar/androidStore.svg';

export default function More() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { getProfile } = useSelector((state) => state?.ProfileSlice);

  const MoreMenu = [
    {
      title: t('More.Profile'),
      startIcon: <UserProfilePic className="start-icon" />,
      icon: <Arrowforward className="right-arrow" />,
      path: () => navigate(`/profile/${getProfile.username}`),
    },
    {
      title: t('More.Settings'),
      startIcon: <Settings className="start-icon" />,
      icon: <Arrowforward className="right-arrow" />,
      path: () => navigate('/settings'),
    },
    {
      title: t('More.PostJob'),
      startIcon: <Work className="start-icon" />,
      icon: <Arrowforward className="right-arrow" />,
      path: () => navigate('/postjob'),
    },
  ];
  return (
    <MoreNavs>
      {MoreMenu.map((item, index) => {
        return (
          <div
            key={index}
            className="more-navs"
            onClick={() => {
              item.path();
            }}
          >
            <div className="more-nav-label">
              {item.startIcon}
              <div>{item.title}</div>
            </div>
            {item.icon}
          </div>
        );
      })}
      <JobFilter onlyAlert={true}>
        <div className="more-navs">
          <div className="more-nav-label">
            <JobAlert className="start-icon" />
            <div>{t('More.JobAlert')}</div>
          </div>
          <Arrowforward className="right-arrow" />
        </div>
      </JobFilter>
      {Capacitor.getPlatform() === 'web' && (
        <div className="more-mobile-download">
          <div className="more-mobile-download-description">
            Download now for a personalized experience
          </div>

          {navigator.userAgent.includes('iPhone') ||
          navigator.userAgent.includes('iPad') ||
          navigator.userAgent.includes('Mac') ? (
            <AppleStore className="appstore-download-img" />
          ) : navigator.userAgent.includes('Android') ? (
            <AndroidStore
              className="appstore-download-img"
              onClick={() =>
                window.open(
                  'https://play.google.com/store/apps/details?id=com.wafynet.myapp&pcampaignid=web_share',
                  '_blank',
                  'noopener,noreferrer'
                )
              }
            />
          ) : null}
        </div>
      )}
    </MoreNavs>
  );
}
